export const REMOVE_INTERNAL_MARKETER_PRODUCT = 'REMOVE_INTERNAL_MARKETER_PRODUCT';
export type REMOVE_INTERNAL_MARKETER_PRODUCT = typeof REMOVE_INTERNAL_MARKETER_PRODUCT;

export interface RemoveInternalMarketerProduct {
    type: REMOVE_INTERNAL_MARKETER_PRODUCT;
    productId: string;
}

export function removeInternalMarketerProductAction(productId: string): RemoveInternalMarketerProduct {
    return {
        type: REMOVE_INTERNAL_MARKETER_PRODUCT,
        productId
    };
}
